export default class SukuPayment extends HTMLElement {
  static get observedAttributes() {
    return ['show', 'available', 'button-text', 'variant-id', 'submitting', 'note-text', 'note-show']
  }

  constructor() {
    super()

    this.submitting = false
    this.success = false

    this.className = 'hidden py-4 block'

    this.toggle.bind(this)
    this.updateSubmit.bind(this)
  }

  async handleForm(evt) {
    evt.preventDefault()

    this.setAttribute('submitting', true)

    document.body.classList.add('open-cart');
    document.body.classList.add('hideheader');

    setTimeout(() => {
      this.setAttribute('submitting', false)
    }, 300)
  }

  toggle(element, state) {
    if (state) {
      element.classList.remove('hidden')  
    } else {
      element.classList.add('hidden')
    }
  }

  updateSubmit() {
    if (this.submitting) {
      this.button.textContent = this.getAttribute('submit')
      this.button.setAttribute('disabled', true)
    } else {
      this.button.textContent = this.getAttribute('button-text')
      this.button.removeAttribute('disabled')
    }
  }

  connectedCallback() {
    this.show = this.getAttribute('show') === 'true' ? true : false
    this.available = this.getAttribute('available') === 'true' ? true : false
    this.buttonText = this.getAttribute('button-text')
    this.variantId = this.getAttribute('variant-id')
    this.noteText = this.getAttribute('note-text')
    this.noteShow = this.getAttribute('note-show') === 'true' ? true : false

    this.setAttribute('submit', 'Adding...')
    this.setAttribute('button-text', 'Add to cart')

    const form = document.createElement('form')
    form.setAttribute('action', '/cart/add')
    form.setAttribute('method', 'POST')
    form.setAttribute('enctype', 'multipart/form-data')
    form.setAttribute('data-type', 'add-to-cart-form')
    form.setAttribute('data-cart-submit', 'data-cart-submit')
    
    const input = document.createElement('input')
    input.setAttribute('type', 'hidden')
    input.setAttribute('name', 'id')
    input.setAttribute('value', '')
    input.setAttribute('data-input-variant', '')

    const button = document.createElement('button')
    button.setAttribute('type', 'submit')
    button.setAttribute('name', 'add')
    button.setAttribute('disabled', true)
    button.className = 'cartButton is-primary text-base text-black bg-white font-normal hover:text-white hover:bg-black min-h-[44px] disabled:text-black disabled:opacity-50 disabled:hover:bg-white'
    button.textContent = this.buttonText

    const note = document.createElement('p')
    note.className = 'hidden mt-2.5 mobile:mt-2 text-sm text-center'
    note.textContent = this.noteText

    form.appendChild(input)
    form.appendChild(button)

    this.form = form
    this.input = input
    this.button = button
    this.note = note

    this.appendChild(form)
    this.appendChild(note)

    this.form.addEventListener('submit', this.handleForm.bind(this))
  }

  disconnectedCallback() {
    window.clearInterval(this.interval)
  }

  attributeChangedCallback(name, current, value) {
    if (current === value) {
      return
    }

    switch (name) {
      case 'show' :
        this.show = value === 'true' ? true : false

        this.toggle(this, this.show)
        break
      case 'available' :
        this.available = value === 'true' ? true : false

        if (this.button) {
          if (this.available) {
            this.button.removeAttribute('disabled')
          } else {
            this.button.setAttribute('disabled', true)
          }
        }

        break
      case 'submitting' :
        this.submitting = value === 'true' ? true : false

        this.updateSubmit()
        break
      case 'variant-id' :
        this.variantId = value

        if (this.input) {
          this.input.value = value
        }

        break
      case 'note-text' :
        this.noteText = value

        if (this.note) {
          this.note.textContent = this.noteText
        }
      break
      case 'note-show' :
        this.noteShow = value === 'true' ? true : false

        if (this.note) {
          this.toggle(this.note, this.noteShow)
        }
        break
      case 'button-text' :
        this.buttonText = value

        if (this.button) {
          this.button.textContent = value
        }
      break
    }
  }
}

customElements.define('suku-payment', SukuPayment)
